import React, { useState } from 'react';

import PageBannerDismissable from '../../../../../components/PageBannerDismissable/PageBannerDismissable';
import { AlertBox } from 'mdi-material-ui';
import useStyles from './CoSellTestEnvironmentBanner.styles';
import { useTheme } from '../../../../../vendor/material';
import { useIsDemoEnvironment } from '../../../../../hooks';
import { getEnvironmentBannerText } from 'AppLayout';
import { EnvironmentColorMap } from 'components/ApplicationShell/hooks/useEnvironmentColor';

export const CoSellTestEnvironmentBanner = ({ isV3 }: { isV3: boolean }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [isTestEnvBannerOpen, setIsTestEnvBannerOpen] = useState(true);
  const isDemoEnvironment = useIsDemoEnvironment();
  const showBanner = isV3 && isTestEnvBannerOpen && isDemoEnvironment;

  return (
    <div className={classes.root}>
      {showBanner && (
        <PageBannerDismissable
          text={getEnvironmentBannerText('demo')}
          icon={
            <AlertBox
              role={'img'}
              aria-hidden={false}
              htmlColor={theme.palette.NEUTRAL700}
            />
          }
          className={classes.pageBanner}
          bannerColor={EnvironmentColorMap.demo}
          textColor={theme.palette.NEUTRAL700}
          onClose={() => setIsTestEnvBannerOpen(false)}
        />
      )}
    </div>
  );
};
